import React from 'react';
import { GlobeIcon } from 'lucide-react';
import { Eyebrow, SectionShell, SectionTitle } from '../SectionShell';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
import { valueRows } from '../../data/content';
export function Offer() {
  return <SectionShell id="oferta" tone="cream" data-id="element-200" data-mp="3575dy5ma483p">
      <Eyebrow data-id="element-201" data-mp="353zqeutatea3">La oferta</Eyebrow>
      <SectionTitle data-id="element-202" data-mp="3a68htmqiw8a3">Todo este sistema podría venderse por mucho más</SectionTitle>
      <p className="mt-4 text-center text-[15px] leading-relaxed text-navy-700/80 sm:text-lg" data-id="element-203" data-mp="3f4a2ud7ieho7">
        Porque no estás comprando PDFs. Estás adquiriendo un sistema que puede ahorrarte años de
        ensayo y error frente al paciente renal.
      </p>

      <div className="mt-8 overflow-hidden rounded-3xl border border-navy-100 bg-white" data-id="element-204" data-mp="3nw27u8drkyle">
        <div className="flex items-center justify-between gap-3 border-b border-navy-100 bg-navy-800 px-4 py-3 sm:px-6" data-id="element-205" data-mp="3sxhu23rohb5d">
          <span className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-white" data-id="element-206" data-mp="1nj5pq7tgk7r">
            Lo que recibes
          </span>
          <span className="text-[11px] font-extrabold uppercase tracking-[0.14em] text-renal-400" data-id="element-207" data-mp="1flvl66405y5k">
            Valor
          </span>
        </div>
        <ul data-id="element-208" data-mp="1bl1zlje18vfu">
          {valueRows.map(row => <li key={row.label} className="flex items-start justify-between gap-3 border-b border-navy-100 px-4 py-3.5 sm:px-6" data-id="element-209" data-mp="16m8ilgzjemax">
              <span className="text-[13.5px] font-semibold leading-snug text-navy-800 sm:text-[15px]" data-id="element-210" data-mp="23dslp12053rd">
                {row.label}
              </span>
              <span className="shrink-0 text-[13px] font-bold text-navy-600/60 line-through sm:text-[15px]" data-id="element-211" data-mp="1uicxazk0ngt6">
                {row.value}
              </span>
            </li>)}
        </ul>
        <div className="flex items-center justify-between gap-3 bg-cream-100 px-4 py-4 sm:px-6" data-id="element-212" data-mp="2n10a7rouzpj6">
          <span className="font-display text-[15px] font-extrabold text-navy-900 sm:text-lg" data-id="element-213" data-mp="2i875v4xayj7m">
            Valor total del sistema
          </span>
          <span className="font-display text-[19px] font-extrabold text-navy-900 line-through sm:text-2xl" data-id="element-214" data-mp="317tn8l30rw85">
            USD 292
          </span>
        </div>
      </div>

      <div className="mt-8 rounded-3xl border-2 border-renal-500 bg-white px-4 py-7 text-center sm:px-8" data-id="element-215" data-mp="2scnlpyas80bf">
        <p className="text-[13.5px] font-semibold text-navy-700/80 sm:text-base" data-id="element-216" data-mp="2wcxufipyl4tz">
          Hoy no pagarás USD 292. Ni USD 97.
        </p>
        <p className="mt-2 text-[12px] font-bold uppercase tracking-[0.14em] text-renal-700" data-id="element-217" data-mp="2ndswoem81fiv">
          Acceso inmediato por solo
        </p>
        <p className="mt-1 font-display text-[62px] font-extrabold leading-none text-navy-900 sm:text-7xl" data-id="element-218" data-mp="29fmdm4lxlk39">
          <span className="align-top text-2xl font-bold sm:text-3xl" data-id="element-219" data-mp="2dgenn02mnt0l">USD </span>15
        </p>
        <p className="mt-3 text-[13.5px] font-semibold leading-relaxed text-navy-700/85 sm:text-[15px]" data-id="element-220" data-mp="7ng3ij0nkur6">
          Pago único. Acceso de por vida. Sin mensualidades. Sin costos ocultos.
        </p>

        <p className="mx-auto mt-4 flex w-fit items-center gap-2 rounded-full bg-navy-50 px-3.5 py-2 text-[11.5px] font-semibold text-navy-700 sm:text-xs" data-id="element-221" data-mp="1w73rcidi8hy7">
          <GlobeIcon className="h-4 w-4 shrink-0 text-renal-600" aria-hidden="true" data-id="element-222" data-mp="25wx3bkhk6z2z" />
          El cambio de moneda es automático según tu país
        </p>

        <div className="mt-6" data-id="element-223" data-mp="214ccmrty923o">
          <CtaButton size="lg" label="Quiero acceder a la Ruta Renal™" sub="Descarga inmediata • Garantía de 7 días • Acceso para siempre" data-id="element-224" data-mp="2fub7akmapvee" />
        </div>

        <div className="mt-6" data-id="element-225" data-mp="2ouzmvjrc83te">
          <Countdown data-id="element-226" data-mp="2ou6p38acwone" />
        </div>

        <div className="mt-6" data-id="element-227" data-mp="2ot5awuy1nm1g">
          <ScarcityBar data-id="element-228" data-mp="2jwen1lfzzm5h" />
        </div>
      </div>
    </SectionShell>;
}